const VERSION_DATA_CENTER = "base-platform/v2"
// const bizType= window.sessionStorage.getItem('bizType')

// 判断用户是否绑定手机号公众号用户
export const wechatsubscribe = {
    url: `/${VERSION_DATA_CENTER}/wechat/subscribe/get?signature=9fcb3068f965117b6eb3a0340c3de6448bf5db53&timestamp=1661929413&echostr&nonce=1418963285`,
    method: "POST",
}
// 绑定或者解绑公众号用户
export const subscribeopenidphone = {
    url: `/${VERSION_DATA_CENTER}/wechat/subscribe/openid/phone?signature=9fcb3068f965117b6eb3a0340c3de6448bf5db53&timestamp=1661929413&echostr&nonce=1418963285`,
    method: "POST",
}
// 校验微信用户是否关注公众号
export const wechatCheck = {
    url: `/${VERSION_DATA_CENTER}/wechat/check`,
}



//手机验证码
export const commonsmscaptcha = {
    url: `/${VERSION_DATA_CENTER}/base/common/sms/captcha`,
    method: "POST",
}

